/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from "vue-svgicon";
icon.register({
  "tab-active": {
    width: 20,
    height: 10,
    viewBox: "0 0 20 10",
    data:
      '<g transform="translate(-494.000000, -270.000000)" fill="#FFFFFF" stroke="#E6EAED"><g transform="translate(396.000000, 136.000000)"><polyline points="98 135 107.778804 144 117.5 135"></polyline></g></g>',
  },
});
